import SuriZungliPage from '../pages/Homepage';
import BlogPage from '../pages/Blog';
import ArticlePage from '../pages/Blog-Article';
import { useParams } from 'react-router-dom';

const ArticlePageWrapper = () => {
  const { slug } = useParams();
  return <ArticlePage slug={slug} />;
};

const mainRoutes = [
  { 
    path: '/', 
    element: <SuriZungliPage /> 
  },
  { 
    path: '/blog', 
    element: <BlogPage /> 
  },
  { 
    path: '/blog/:slug', 
    element: <ArticlePageWrapper /> 
  }
];

export default mainRoutes;